<app-header></app-header>
<!-- <div id="countdown" class="blackbg">
    <div id="countdown-number">{{display}}</div>
    <svg>
      <circle r="18" cx="20" cy="20"></circle>
    </svg>
    <span>
      <p class="warningtext">Please Do Not Click Back button or refresh</p>
    </span>
  </div> -->
  <div class="allblack">
    <div id="countdown" class="blackbg">
      <div id="countdown-number">{{display}}</div>
      <svg>
        <circle r="48" cx="50" cy="50"></circle>
      </svg>
    </div>
    <span>
      <p class="warningtext">Please Do Not Click Back button or refresh</p>
    </span>
  </div>

  <ng-template #mymodal8 let-modal8>
    <div class="modal-body modal_open d-fl-wr d-flex align-items-center justify-content-center">
        <div class="d-md-flex align-items-center py-4">
            <div class="col-md-9"> 
                <p class="text-center text-foc">Payment Failure...!! Please try again.</p>
                <div class="d-flex align-items-center justify-content-center">
                    <button class="continue-btn" (click)="close()">Okay</button>
                </div>
            </div>
        </div>
    </div>
</ng-template>
  
<app-footer></app-footer>